import angular from 'angular';
import { OrganizationService } from './organization.service';

const organizations = angular.module('organizations', []);

organizations.service('Organization', OrganizationService);

export const OrganizationsModule = organizations;